module.exports = __webpack_public_path__ + "static/logo-horizontal-61f73b93a23946c41cb31233e9ebeb53.svg";